export default {
      id: "icon_nih-usage",
      viewBox: "0 0 36 23",
      url: __webpack_public_path__ + "sprite.svg#icon_nih",
      toString: function () {
        return this.url;
      }
    }